import { icons, type WsShellApp } from '@platform/ui-kit/workspace';

/**
 * The workspace navigation's glyph for each module, by the catalogue's `icon` name. The Classic
 * shell uses Material icons (`getModuleIcon`); the workspace set is Lucide (owner ruling
 * 2026-10-20), so the ten modules are mapped here once. An unmapped name falls back to a
 * generic tile rather than failing, so a new module never breaks the drawer.
 */
const MODULE_GLYPH: Record<string, WsShellApp['icon']> = {
  apr: icons.LayoutGrid,
  portfolio_definition: icons.Library,
  spn: icons.Gauge,
  ai_readiness: icons.Sparkles,
  erp_consolidation: icons.GitBranch,
  program_planning: icons.CalendarRange,
  project_management: icons.KanbanSquare,
  request_quote: icons.ReceiptText,
  licensing_usage: icons.KeyRound,
  admin: icons.Settings,
};

export const moduleGlyph = (name: string): WsShellApp['icon'] =>
  MODULE_GLYPH[name] ?? icons.LayoutGrid;
